import { DataSourceMode, Label, LookupModelSelectionEvent, TableRow, TableRowCreationEvent, TableRowDisplayEvent, TableRowMode, Textbox, ValidationResult } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommFilterJunctionUnitTable } from "./autogen/AutogenLayoutMobileCommFilterJunctionUnitTable";

export class MobileCommFilterJunctionUnitTable extends AutogenLayoutMobileCommFilterJunctionUnitTable {
    tableMcFilterJunctionUnitOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();

        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            const labelDescription = tableRow.findComponentById("labelDescription") as Label;
            labelDescription.marginTop = 12;

            const labelUnitType = tableRow.findComponentById("labelUnitType") as Label;
            labelUnitType.marginTop = 12;

            const labelUnitVendor = tableRow.findComponentById("labelUnitVendor") as Label;
            labelUnitVendor.marginTop = 12;
        }

        const labelUnitType = tableRow.findComponentById("labelUnitType") as Label;
        labelUnitType.allowTooltip = false;
    }

    async textboxUnitOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        if (selectedRow) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            const textboxUnit: Textbox = tableRow.findComponentById("textboxUnit") as Textbox;

            textboxUnit.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    component: textboxUnit,
                    isValid: true
                }

                this.tableMCFilterJunctionUnit.rows.forEach(row =>  {
                    if (event.selection.get("id") === row.data.get("mc_object_id")) {
                        result.isValid = false;
                        result.validationMessage = "Row already exists for this unit";
                        return;
                    }
                });
                return result;
            };

            const labelDescription: Label = tableRow.findComponentById("labelDescription") as Label;
            labelDescription.text = event.selection.get("descr");

            const labelUnitVendor: Label = tableRow.findComponentById("labelUnitVendor") as Label;
            labelUnitVendor.text = event.selection.get("mc_control_id");

            const labelUnitType: Label = tableRow.findComponentById("labelUnitType") as Label;
            labelUnitType.text = event.selection.get("mc_unit_type");

            if (labelUnitType.text === 'D') {
                labelUnitType.text = "Driver";
            } else if (labelUnitType.text === 'T') {
                labelUnitType.text = "Tractor";
            } else if (labelUnitType.text === 'L') {
                labelUnitType.text = "Trailer";
            } else if (labelUnitType.text === 'M') {
                labelUnitType.text = "Movement";
            } else if (labelUnitType.text === 'B') {
                labelUnitType.text = "Borrowed Trailer";
            }
        }
    }

    tableMCFilterJunctionUnitOnRowCreate(event: TableRowCreationEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        const lmData = modelRow.getLookupModelData("mc_object_id");

        if (lmData) {
            modelRow.set("mc_unit.descr", lmData[0].get("descr"));
            modelRow.set("mc_unit.mc_unit_type", lmData[0].get("mc_unit_type"));
            modelRow.set("mc_unit.mc_control_id", lmData[0].get("mc_control_id"));
        }
    }
}
